import Tween from "tween.ts";
import Animation from "../Animation";
import Angle from "../../entities/Angle/Angle";

export default class DrawAngleAnim extends Animation {
  constructor(Angle: Angle, onComp: () => void) {
    super();
    new Tween.Tween(Angle)
      .to({ scale: 1 }, 500)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => onComp())
      .start()
  }
}